import { reactive } from 'vue'

interface RouterKeyState {
  key: number
}

// Simple reactive state for router key
const state = reactive<RouterKeyState>({
  key: 0
})

export const routerKeyState = {
  get key(): number {
    return state.key
  },

  // Force re-render by incrementing key
  forceRerender(): void {
    state.key++
  }
}
